import React from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Tooltip, Button } from "@nextui-org/react";
import TitleModal from "./styled-components/TitleModal";


const PreventKeyDeletionModal = ({ visible, onCloseModal, isLoading, onConfirm, keyToDelete }) => {
    const onDelete = () => {
        onConfirm(keyToDelete)
    }

    return (
        <Modal backdrop="blur" isOpen={visible} size="1xl" hideCloseButton>
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">
                            <TitleModal className="text-center">Eliminar</TitleModal>
                        </ModalHeader>
                        <ModalBody>
                            <div className="flex gap-x-1 w-full justify-center">
                                <p className="text-center">¿Seguro que queres eliminar la clave</p>
                                <p className="text-center font-extrabold underline">{keyToDelete}</p>
                                <p className="text-center">?</p>
                            </div>
                            <div className="flex w-full justify-center gap-3 mt-4">
                                <Button className="bg-slate-500 rounded-xl" isDisabled={isLoading} onClick={onCloseModal}>
                                    <p className="text-white p-3">
                                        Cancelar
                                    </p>
                                </Button>
                                <Button
                                    onClick={onDelete}
                                    className="bg-red-600 rounded-xl"
                                    isLoading={isLoading}
                                >
                                    <p className="text-white p-3">
                                        Si, eliminar
                                    </p>
                                </Button>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

export default PreventKeyDeletionModal;
